/** Wrap a handler so it only runs once the card id is known (the detail page renders before the id resolves). */
export function guardCard(cardId: number | undefined) {
  return <A extends unknown[]>(fn: (id: number, ...args: A) => void) =>
    (...args: A) => {
      if (!cardId) return
      fn(cardId, ...args)
    }
}
